define("shared/components/shared/post/secondary/caption-writer/header", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="o--modalHeader tCW--modalHeader" ...attributes data-test-id="header-root">
    <div class="tCW--modalHeader__header">
      {{! Button - Left }}
      <Shared::Ui::Button
        @class="u--p__0 qa--aiCaptions_backBtn {{unless this.canNavigateBack 'u--transparent o--btn--disabled'}}"
        @onClick={{@navigateBack}}
        @variant="unstyled"
        data-test-id="caption-writer-modal-back-button"
      >
        {{svg-jar "arrow-left" class="o--icon o--icon--hl tCW--modalHeader__actionBtn"}}
      </Shared::Ui::Button>
      {{! Title }}
      <h3 class="o--modalHeader__title tCW--modalHeader__title">
        {{t "caption_writer.title"}}
        <Shared::Ui::Button
          @class="u--p__0 qa--aiCaptions_infoModalBtn"
          @onClick={{@toggleInfoModal}}
          @variant="unstyled"
          data-test-id="caption-writer-info-modal-button"
        >
          {{svg-jar "info" class="o--icon o--icon--light u--m__l__xs"}}
        </Shared::Ui::Button>
      </h3>
      {{! Button - Right }}
      <Shared::Ui::Button
        @class="qa--alert_closeIcon"
        @onClick={{@toggleCaptionWriterModal}}
        @variant="unstyled"
        data-test-id="caption-writer-modal-toggle-button"
      >
        {{svg-jar "close" class="o--icon o--icon--light tCW--modalHeader__actionBtn"}}
      </Shared::Ui::Button>
    </div>
  
    {{#if (and @shouldDisplayNoRemainingCaptions (not @shouldDisplayCreditPurchase))}}
      <div class="tCW--modalHeader__Banner" data-test-id="header-no-credits-banner">
        <p class="u--m__0">
          {{svg-jar "info" class="o--icon u--m__r__xs"}}
          <span>
            {{t "caption_writer.no_credits_left"}}
          </span>
          <Shared::Ui::Button
            @class="u--text--success"
            @onClick={{@showCreditPurchase}}
            @text={{t "caption_writer.get_more_credits"}}
            @variant="actionLink"
            data-test-id="header-show-credit-purchase-button"
          />
        </p>
      </div>
    {{else if (and @showCreditsDescription @isFreeOrLegacyUser)}}
      <p class="u--text--light u--m__t u--m__b__0" data-test-id="header-free-description">
        {{t "caption_writer.free_description"}}
      </p>
    {{else if (eq @remainingCaptionGenerationUsages 0)}}
      <p class="u--m__t u--m__b__xs" data-test-id="caption-writer-usage-warning">
        {{t
          "caption_writer.usage_warning.counter_alt"
          creditsForPlan=@creditCountForPlan
          remainingCredits=@remainingCaptionGenerationUsages
        }}
      </p>
      <p class="u--text--light u--m__0" data-test-id="credit-reset-date">
        {{t "caption_writer.credit_reset_date" date=@nextCreditUpdate}}
      </p>
    {{/if}}
  </div>
  
  {{#if @displayInfoModal}}
    <Shared::Portal @destinationElement="root-portal">
      <Shared::Post::Secondary::CaptionWriter::InfoModal
        @closeModal={{@toggleInfoModal}}
        @onSeamlessCheckoutSuccess={{this.onSeamlessCheckoutSuccess}}
      />
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "3aOmchxf",
    "block": "[[[11,0],[24,0,\"o--modalHeader tCW--modalHeader\"],[17,1],[24,\"data-test-id\",\"header-root\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tCW--modalHeader__header\"],[12],[1,\"\\n\"],[1,\"    \"],[8,[39,0],[[24,\"data-test-id\",\"caption-writer-modal-back-button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[[29,[\"u--p__0 qa--aiCaptions_backBtn \",[52,[51,[30,0,[\"canNavigateBack\"]]],\"u--transparent o--btn--disabled\"]]],[30,2],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"arrow-left\"],[[\"class\"],[\"o--icon o--icon--hl tCW--modalHeader__actionBtn\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"],[1,\"    \"],[10,\"h3\"],[14,0,\"o--modalHeader__title tCW--modalHeader__title\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"caption_writer.title\"],null]],[1,\"\\n      \"],[8,[39,0],[[24,\"data-test-id\",\"caption-writer-info-modal-button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[\"u--p__0 qa--aiCaptions_infoModalBtn\",[30,3],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,2],[\"info\"],[[\"class\"],[\"o--icon o--icon--light u--m__l__xs\"]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[8,[39,0],[[24,\"data-test-id\",\"caption-writer-modal-toggle-button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[\"qa--alert_closeIcon\",[30,4],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"close\"],[[\"class\"],[\"o--icon o--icon--light tCW--modalHeader__actionBtn\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[28,[37,5],[[30,5],[28,[37,6],[[30,6]],null]],null],[[[1,\"    \"],[10,0],[14,0,\"tCW--modalHeader__Banner\"],[14,\"data-test-id\",\"header-no-credits-banner\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--m__0\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"info\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"caption_writer.no_credits_left\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,0],[[24,\"data-test-id\",\"header-show-credit-purchase-button\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--text--success\",[30,7],[28,[37,3],[\"caption_writer.get_more_credits\"],null],\"actionLink\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,5],[[30,8],[30,9]],null],[[[1,\"    \"],[10,2],[14,0,\"u--text--light u--m__t u--m__b__0\"],[14,\"data-test-id\",\"header-free-description\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"caption_writer.free_description\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,10],0],null],[[[1,\"    \"],[10,2],[14,0,\"u--m__t u--m__b__xs\"],[14,\"data-test-id\",\"caption-writer-usage-warning\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"caption_writer.usage_warning.counter_alt\"],[[\"creditsForPlan\",\"remainingCredits\"],[[30,11],[30,10]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--light u--m__0\"],[14,\"data-test-id\",\"credit-reset-date\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"caption_writer.credit_reset_date\"],[[\"date\"],[[30,12]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]]],[]]],[13],[1,\"\\n\\n\"],[41,[30,13],[[[1,\"  \"],[8,[39,8],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,9],null,[[\"@closeModal\",\"@onSeamlessCheckoutSuccess\"],[[30,3],[30,0,[\"onSeamlessCheckoutSuccess\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"&attrs\",\"@navigateBack\",\"@toggleInfoModal\",\"@toggleCaptionWriterModal\",\"@shouldDisplayNoRemainingCaptions\",\"@shouldDisplayCreditPurchase\",\"@showCreditPurchase\",\"@showCreditsDescription\",\"@isFreeOrLegacyUser\",\"@remainingCaptionGenerationUsages\",\"@creditCountForPlan\",\"@nextCreditUpdate\",\"@displayInfoModal\"],false,[\"shared/ui/button\",\"unless\",\"svg-jar\",\"t\",\"if\",\"and\",\"not\",\"eq\",\"shared/portal\",\"shared/post/secondary/caption-writer/info-modal\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/header.hbs",
    "isStrictMode": false
  });
  class HeaderComponent extends _component2.default {
    get canNavigateBack() {
      if (!this.args.navigationState) {
        return false;
      }
      return this.args.navigationState.current !== 'root';
    }
  }
  _exports.default = HeaderComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, HeaderComponent);
});